import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'

export function ClosedText({info}: {info: IssueEventInfo}) {
  const {stateReason} = info
  return <>{stateReason === 'not_planned' ? 'closed this as not planned' : 'closed this PR'}</>
}
